const HELP_CENTER_URL = 'https://hjelpesenter.finn.no/hc/no/articles/35180815034898-Kontrakter-Feriehjem-og-hytter-til-leie-i-utlandet';

export const RentalContractInfo = () => (
    <section className="mx-0 p-16 rounded-8 s-bg-info-subtle">
        <h2 className="h4">Trenger du leiekontrakt?</h2>
        <p>Last ned våre standardiserte maler for leieforhold i utlandet.</p>
        <a href={HELP_CENTER_URL} target="_blank" rel="noopener noreferrer" className="link">
            Les mer og last ned her
        </a>
    </section>
);
